import { createRoot } from "react-dom/client";
import Comparison from "@/features/widgets/components/Comparison/Comparison.tsx";
import WidgetWrapper from "@/components/WidgetWrapper.tsx";
import ScriptHelper from "@/utils/scriptHelper.tsx";
import ComparisonHelper from "@/features/widgets/components/Comparison/utils/comparisonHelper.tsx";
import SelectionHelper from "@/features/widgets/components/Selection/utils/SelectionHelper.tsx";
import Selection from "@/features/widgets/components/Selection/Selection.tsx";

class WidgetHelper {

  public static WIDGET_TYPE_BUTTON_COMPARE = `button-compare`;
  public static WIDGET_TYPE_CHECKBOX_COMPARE = `checkbox-compare`;
  public static WIDGET_TYPE_COMPARISON = `comparison`;

  public static initialize = () => {
    this.initializeContainer();
    this.initializeWidgets();
    this.observeDom();
  }

  private static initializeContainer = () => {
    const widgetId = `ws-widgets-container`;
    let element = document.getElementById(widgetId);
    if (element) {
      return;
    }

    element = document.createElement(`div`);
    element.setAttribute(`id`, widgetId);
    document.body.appendChild(element);

    createRoot(element).render(
      <WidgetWrapper>
        <Comparison/>
        <Selection/>
      </WidgetWrapper>
    );
  }

  private static initializeWidgets = () => {
    ComparisonHelper.initialize();
    SelectionHelper.initialize();

    const widgets = this.getWidgets();
    widgets.forEach(widget => {
      if (widget.getAttribute(`data-ws-initialized`)) {
        return;
      }

      const type = widget.getAttribute(`data-ws-widget-type`);
      if (!type) {
        return;
      }

      ComparisonHelper.initializeWidget(widget, type);
      SelectionHelper.initializeWidget(widget, type);

      widget.setAttribute(`data-ws-initialized`, `true`);
    });
  }

  public static getWidgets = () => {
    const result = document.querySelectorAll(`[data-ws-widget-type]`) as NodeListOf<HTMLElement>;
    return result;
  }

  public static getCurrentLanguage = () => {
    return ScriptHelper.getScriptElement()?.getAttribute(`data-ws-language`) || document.documentElement.lang;
  }

  private static observeDom = () => {
    const observer = new MutationObserver((mutations) => {
      const hasNewWidgets = mutations.some(mutation =>
        Array.from(mutation.addedNodes).some(node =>
            node instanceof HTMLElement && (
              node.hasAttribute(`data-ws-widget-type`) ||
              node.querySelector?.(`[data-ws-widget-type]`)
            )
        )
      );

      if (hasNewWidgets) {
        this.initializeWidgets();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

}

export default WidgetHelper;

